var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-settings-wrapper"},[(_vm.isLoading)?_c('div',{staticClass:"loading-state"},[_c('p',[_vm._v("Authenticating...")])]):_vm._e(),(_vm.hasError)?_c('div',{staticClass:"error-state"},[_c('h3',[_vm._v("Authentication Failed")]),_c('p',[_vm._v(_vm._s(_vm.errorMessage))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }